import { Collapse } from 'element-ui'

const YCollapse = Collapse
YCollapse.$depends = [Collapse]
YCollapse.$name = 'y-collapse'
YCollapse._name = 'Collapse 折叠面板'

export default YCollapse
